export default function generateQueryParams(options = {}, defaultValues = {}) {
    const mergedOptions = {
        ...defaultValues,
        ...Object.fromEntries(
            Object.entries(options).filter(
                ([, value]) => value !== null && value !== ''
            )
        )
    };

    const queryString = Object.entries(mergedOptions)
        .filter(
            ([, value]) =>
                value !== '' &&
                value !== undefined &&
                value !== null &&
                !(Array.isArray(value) && value.length === 0)
        )
        .map(
            ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&');

    return queryString ? `?${queryString}` : '';
}
